export default __webpack_public_path__ + "static/media/light_cavalry.c93a68fd.png";